module.exports = __webpack_public_path__ + "img/q4-10.2541166c.png";